import { UniqueAdvertiser } from '@/common/models';
import { QueryParams } from '@/common/models/query-params';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetAllQuery } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_UNIQUE_ADVERTISERS_LIST } from '@/org-app/store/modules/advertisers/mutation-types';

export const useUniqueAdvertisers = createGetAllQuery<UniqueAdvertiser>(
  [queryKeys.uniqueAdvertisers],
  () => OrgAppAPIProxy.instance.getUniqueAdvertisers({ queryParams: QueryParams.all() }),
  (data) => {
    orgAppStore.modules.Advertisers.mutations[UPDATE_UNIQUE_ADVERTISERS_LIST](
      orgAppStore.modules.Advertisers.state,
      data,
    );
  },
);

export const useUniqueAdvertisersWithBuyers = createGetAllQuery<UniqueAdvertiser>(
  [queryKeys.uniqueAdvertisersWithBuyer],
  () => OrgAppAPIProxy.instance.getUniqueAdvertisersWithBuyer({ queryParams: QueryParams.all() }),
);
